import { forwardRef } from "react";

import instructions from "../../assets/video/instructies.webm";
import { ButtonBottomRight } from "../Button";

import { Video } from "./components";

export type Props = {
  readonly onEnded: () => void;
  readonly isVisible: boolean;
};

const Instructions = forwardRef<HTMLVideoElement, Props>(
  ({ onEnded, isVisible }, ref) => (
    <>
      <Video
        src={instructions}
        onEnded={onEnded}
        ref={ref}
        isVisible={isVisible}
      />
      {isVisible && (
        <ButtonBottomRight onClick={onEnded}>
          Skip instructies
        </ButtonBottomRight>
      )}
    </>
  )
);

export default Instructions;
